import { useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { RoutesWrapper } from "./styles";
import { ROUTES } from "../../components/piOnboarding/steps/constants";
import Container from "../../components/piOnboarding/steps/container";
import Identification from "../../components/piOnboarding/steps/Identification";
import PrivateInformation from "../../components/piOnboarding/steps/privateInformation";
import About from "../../components/piOnboarding/steps/AboutServices";
import { YES_NO_VAL } from "../../components/PIForm/Steps/step3/utils";
import { FormProvider, useForm } from "react-hook-form";
import useScrollToTop from "../../hooks/useScrollToTop";

function PiOnboardingRoutes() {
  const { pathname } = useLocation();
  const scrollToTop = useScrollToTop();
  const methods = useForm({
    shouldUnregister: false,
    defaultValues: {
      dualCitizenShip: YES_NO_VAL.no.toString(),
      isGreenCardHolder: YES_NO_VAL.no.toString(),
      isPep: YES_NO_VAL.no.toString(),
      tax_residency_question: YES_NO_VAL.no.toString(),
      tax_residency_countries: [{ countryId: "", taxCode: "" }],
    },
  });

  useEffect(() => {
    scrollToTop();
  }, [pathname, scrollToTop]);

  return (
    <RoutesWrapper>
      <Container>
        <FormProvider {...methods}>
          <Switch>
            <Route
              path={`/pi-onboarding/${ROUTES.identification}`}
              component={Identification}
            />

            <Route
              path={`/pi-onboarding/${ROUTES.privateInformation}`}
              component={PrivateInformation}
            />
            <Route
              path={`/pi-onboarding/${ROUTES.aboutServices}`}
              component={About}
            />
            <Redirect to={`/pi-onboarding/${ROUTES.identification}`} />
          </Switch>
        </FormProvider>
      </Container>
    </RoutesWrapper>
  );
}

export default PiOnboardingRoutes;
